module.exports = __webpack_public_path__ + "static/media/power-def1.04b176fb.png";